<template>
	<div>
		<div :style="{backgroundColor: globalsetting.bcolor,color:globalsetting.fcolor}" style="min-height:100vh;">
			<div style="position: relative;">
				<div class="weui-gallery" id="gallery">
					<span class="weui-gallery__img" id="galleryImg"></span>
					<div class="weui-gallery__opr">
						<a href="javascript:" class="weui-gallery__del">
							<i class="weui-icon-delete weui-icon_gallery-delete"></i>
						</a>
					</div>
				</div>
				<div v-if="!xianshi">
					<Success :globalsetting="globalsetting" :tb="fankuipage" :erweimasign="erweimasign"></Success>
					<br>
					<div class="personr">
						<div class="yulans">
							<br>
							<br>
							<br>
						</div>

					</div>
				</div>

				<div v-if="xianshi">
					<NoticeBar :tb="globalsetting.noticebar" />
					<Swiper :tb="globalsetting.pic.val"></Swiper>
					<div v-if="!globalsetting.pic.val"><br></div>
					<div class="personr">
						<div class="yulans"	
						style="overflow: hidden;"						
							:style="{backgroundColor:globalsetting.fbcolor?globalsetting.fbcolor:'white',borderRadius:globalsetting.pic&&globalsetting.pic.val.length!=0?'0px 0px 5px 5px':''}"
							>
					
							<div v-if="guanbitip">
								<br>
								表单已被管理员关闭
							</div>
							<!-- <br v-if="!globalsetting.topbr"> -->
							

							<div v-if="!globalsetting.topbr">
								<br>
							</div>

							<div v-for="(v,k) in bd" :key="k+1"
								style="width: 100%;display:flex;align-items: center;flex-direction: column;">
								<div class="yulans-itmes">
									
										<div v-if='v.zj==="Texthint"'  :style="{backgroundColor:v.bgcolor}" >
											<div v-html="v.content" class="bianju"
												:style="{'color':v.color,'textAlign':v.textalign,'fontSize':v.fontsize+'px'}">
											</div>
										</div>
										<div v-else-if='v.zj==="pichint"'>
											<a v-if="v.link" :href="v.link?v.link:''">
												<img :src="v.src" alt="" style="width: 100%;" >
											</a>
											
											<a v-else >

												<img :src="v.src" alt="" style="width: 100%;" >
											</a>
										</div>
										<div v-else-if='v.zj==="hiddendirect"' class="bianju">
											<div>
											</div>
										</div>
										<div v-else class="bianju">
											<div :is="v.zj" :tb='v' :tv="k" :globalsetting="globalsetting">
											</div>
										</div>

									

								</div>
								<br>
							</div>

							<div style="width: 100%;display: flex;flex-direction: column;align-items: center;">
	
								
								
								<div class="weui-cells weui-cells_form"  style="width: 95%;background-color: rgb(230, 231, 230);">
									<div class="weui-cell ">
										<div class="weui-cell__bd">
											<textarea class="weui-textarea" placeholder="用;;分隔(英文逗号连续两个)，例如：abc;;def;;ghi;;jkl" rows="4" v-model="shibie"></textarea>
											<a v-if="shibie" @click="shibie=''" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a> 
										</div>
									</div>
								</div>
								<br>
								<div style="display: flex;justify-content: space-around;width: 100%;">

									<van-button style="width:30%"  @click = "shibies(shibie)"  plain>智能识别</van-button>
									<van-button style="width:30%" @click = "clearbd" plain>清空重填</van-button>
		
								</div>

							</div>
							
							<br>

							
							<Buttons :tb="globalsetting.button" v-if="!guanbitip" @submit="submit"></Buttons>
							<br>
							<br>
							<br>
							<br>
						</div>
					</div>
					<br>
					<br>
					<br>
					<br>
					<br>
					<audio autoplay loop
						:src="'http://music.163.com/song/media/outer/url?id='+globalsetting.bmusic+'.mp3'"></audio>

					
				</div>


			</div>
			<br>
			<br>
			<br>
		</div>
	</div>



</template>

<script>

	import Buttons from '@/fields/Buttons';
	import { Notify } from 'vant';
	import { Dialog } from 'vant';
	import QRCode from 'qrcodejs2'
	import RadioTan from '@/fields/RadioTan'
	import TextArea from '@/fields/TextArea'
	import AddPicker from '@/fields/AddPicker'
	import Sign from '@/fields/Sign.vue'
	import DatePicker from '@/fields/DatePicker'
	import Radios from '@/fields/Radio'
	import CheckBox from '@/fields/CheckBox'
	import Addfield from '@/manage/addfield/Addfield.vue'
	import GetLocation from '@/fields/GetLocation'
	import NoticeBar from '@/fields/NoticeBar'
	import Swiper from '@/fields/Swiper'
	import DownloadLink from '@/fields/DownloadLink'
	import Vue from 'vue';
	import { Button } from 'vant';
	import 'vant/lib/index.css';
	import { RadioGroup, Radio } from 'vant';
	import { Field } from 'vant';
	import { Sticky } from 'vant';
	Vue.use(Sticky);
	Vue.use(Field);
	Vue.use(Radio);
	Vue.use(RadioGroup);
	Vue.use(Button);
	import TextBox from '@/fields/TextBox'
	import Star from '@/fields/Star'
	import Uploader from '@/fields/Uploader.vue'
	import Success from '@/fields/Success'
	import axios from '@/js/axios.js'
	import {
		mapMutations,
		mapGetters
	} from 'vuex'
	export default {
		name: 'UpdatePage',
		data() {
			return {
				shibie:"",
				erweimasign: "",
				fankuipage: "",
				allxr: "",
				mid: '28196452',
				fontsize: 50,
				tips: "请联系微信dywj66",
				xianshi: true,
				guanbitip: false,
				bd: [],
				globalsetting: {
					title: "", pic: { name: '', val: '', ismust: '', zj: 'Uploader', maxnum: '5' }
					, noticebar: { text: "" }, bcolor: "",
					linkto: "", bmusic: "", timerswitch: "", fcolor: "",
					button: { text: "", color: "", type: "" }

				}

			}
		},
		mounted() {

		},

		created() {
			
			let hf = window.location.pathname;
			let hfarr = hf.split('/')
			let website = hfarr[hfarr.length - 1];
			let load = weui.loading("获取数据中...")
			axios.post('/ht/getqd', { website }).then(res => {
				
				load.hide();		
				if (res.msg) {
					console.log(res.msg);
				}


				if (res.code && res.code == 400) {
					this.guanbitip = true;
					return this.bd = [];
				}
				if (res.code && res.code == 100) {
					weui.alert(res.msg)
					return this.guanbitip = true;
				}
				if (res.code && res.code == 200) {
					
					this.allxr = res.fankuijson;
					if (res.tips) this.tips = res.tips;
					if (res.globalsetting) {
						this.globalsetting = res.globalsetting;
						if (this.globalsetting.title)
							document.title = this.globalsetting.title
					}
					if(res.globalsetting&&res.globalsetting.wxcard){
						this.wxfengxiang(res.globalsetting.wxcard);
					}
					
					this.$store.state.account = res.count;
					return this.bd = res.datas;
				}
				if (res.code && res.code == 888) {

					res.datas.map(item => {
						if (item.hasOwnProperty('zj') && item.hasOwnProperty('val')) {
							let you = res.hasuser.find(i => {
								if (i.name === item.name && i.val) {

									return i;
								}
							})
							if (you) {
								item.val = you.val
							}

							// item.val = you.val;
							return item;
						}
						return item;
					})


					this.allxr = res.fankuijson;
					if (res.tips) this.tips = res.tips;
					if (res.globalsetting) {
						this.globalsetting = res.globalsetting;
						if (this.globalsetting.title)
							document.title = this.globalsetting.title
					}




					this.bd = res.datas;

				}
				if (res.code && res.code == 657) {
					weui.alert(res.msg);
				}

			}, req => {
				Dialog({ message: '服务器故障，请联系管理员' });
			}
			)





		},
		components: {
			TextBox,
			Uploader,
			Addfield,
			CheckBox,
			Radios,
			DatePicker,
			Sign,
			AddPicker,
			TextArea,
			RadioTan,
			Success,
			Star,
			GetLocation,
			NoticeBar,
			Swiper,
			Buttons,
			DownloadLink

		},
		methods: {
			clearbd(){
				this.bd.forEach(item=>{
					if(item.val&&item.autowrite!='a'){
						item.val = "";
					}
				})
			},
			shibies(str){

		let flag = false;		
			try{
				let arrs =	str.match(/【姓名】(\S+)/);
						if(arrs[1]){
							flag = true
							this.bd.forEach(item=>{
							if(item.name=="学生姓名"){
								item.val = arrs[1];
							}})
					}
				arrs = str.match(/【电话】(\S+)/)
						if(arrs[1]){
							flag = true
							this.bd.forEach(item=>{
								if(item.name =="学生电话"){
									item.val = arrs[1];
								}
							})
						}
						arrs = str.match(/【类型】(\S+)/)
						if(arrs[1]){
							flag = true
							this.bd.forEach(item=>{
								if(item.name =="学习项目"){
									item.val = arrs[1];
								}
							})
						}	
						

			}catch(err){

			}
			
			if(flag) return;
			
				let arr = str.split(";;");
				for(let i in this.bd){
					this.bd[i].val = arr[i];
				}
			},
			exitlogin(){
				axios.post('/logins/exitlogin').then(res=>{

					this.$router.push('/login');
				})
			},
			connectmanager() {

				weui.alert(this.tips);

			},
			submit() {


				//单选框的跳转和隐藏跳转框的跳转
				let tiaozhuan = "";
				let linkval = this.bd.find(item => item.linkval);
				if (linkval && linkval['linkval']) {
					tiaozhuan = linkval['linkval'];
				}

				let arr = this.bd.filter(item => item.hasOwnProperty('name'));
				for (let item of arr) {
					if (item.ismust && !item.val) {
						// return weui.topTips(item.name+'不能为空', 3000);
						return Notify(item.name + '不能为空');
					}
				}


				
			
				let onlyone = arr.filter(item=>item.onlyone==="a").map(item=>{
                   if(item.val)  return {name:item.name,val:item.val};
                }                                
                );
				
                let hfss = window.location.pathname.split('/');
				let websitess = hfss[hfss.length - 1];    
 
               if(onlyone.length!=0){
                axios.post('/ht/searchtel',{onlyone,website:websitess}).then(res=>{
                if(res.code==200){
					this.submit2(arr)
                }else if(res.code==100)
                {
					
                    
							weui.dialog({
							title: res.msg+"重复了,是否继续提交",
						
							className: 'custom-classname',
							buttons: [{
								label: '取消',
								type: 'default',
								onClick: function () { 
						}
							},      
							{
								label: '继续提交',
								type: 'primary',
								onClick:  () => { 			
								this.submit2(arr);
							}
							}]
						});
					
                }
            })
               }             

         



			},
			submit2(arr){
				arr = arr.filter(item => item.val).map(item => {
					let obj = {};
					obj.name = item.name;
					obj.val = item.val;
					obj.zj = item.zj;
					return obj;
				})
				if (arr.length == 0) {
					return weui.alert('无有效数据')
				};


				let arrs = []
				arr.forEach(item => {
					let obj = {};
					if (item.zj == 'Sign') {
						let arf = [];
						arf.push({ data: item.val, name: '888' });
						obj.zj = 'Uploader';
						obj.name = item.name;
						obj.val = arf;
						arrs.push(obj);
					} else {
						for (let bb in item) {
							obj[bb] = item[bb]
						}
						arrs.push(obj);
					}

				})




				if (this.allxr) {
					let xrobj = {};
					let allobj = this.allxr;
					xrobj.stitle = allobj.stitle;
					xrobj.sstitle = allobj.sstitle;
					xrobj.maintitle = allobj.maintitle;
					let cons = arrs.map(item => item.val);
					let ss = allobj.pages.find(item => item.keywords.every(i => cons.includes(i)));
					if (ss) {
						let mss = JSON.parse(JSON.stringify(ss));
						let spic = [];
						for (let i = 0; i < 3; i++) {
							spic.push(...mss.spic.splice(Math.floor(Math.random() * mss.spic.length), 1));
						}

						xrobj = { ...xrobj, ...ss, spic };
						this.fankuipage = xrobj;
					} else {
						this.fankuipage = "";
					}
				}

				var loading = weui.loading('提交中...');
				let hf = window.location.pathname;
				let hfarr = hf.split('/')
				let website = hfarr[hfarr.length - 1];
				axios.post('/ht/savedata', { htdata: arrs, website: website }).then(res => {
					if (res.smsg) {
						weui.alert(res.smsg);
					}
					if (res.code == 100) {
						loading.hide();

						weui.alert(res.msg)
					} else if (res.code == 200) {
						loading.hide();
						weui.alert('提交成功!')
						// weui.alert('提交成功');
						if (tiaozhuan) {
							window.location.href = tiaozhuan;
						}

						if (res.erweimasign) {
							this.erweimasign = res.erweimasign
						}

						} else {
						loading.hide();
						weui.alert('提交失败，请重试');
					}
				}).catch(res => {
					loading.hide();
					weui.alert('服务器故障，请联系管理员');
				})

			},
			wxfengxiang(wxcard){
				
				//微信分享链接
				wx.config({
					debug: false,
					appId: 'wxa1b90d05ad8970b5',
					timestamp: '1614910753',
					nonceStr: 'elNjcxpzURfiDnLr',
					signature: 'aaaccc5cc469dc35f7c5c06aa5c2a969c137ddd9',
					jsApiList: [
					// 所有要调用的 API 都要加到这个列表中
					'checkJsApi',
						'onMenuShareTimeline',
						'onMenuShareAppMessage',
						'onMenuShareQQ',
						'onMenuShareWeibo'
					]
				});
				wx.ready(function () {
				// 1 判断当前版本是否支持指定 JS 接口，支持批量判断
				wx.checkJsApi({
					jsApiList: [
					'getNetworkType',
					'previewImage',
					'onMenuShareTimeline',
					'onMenuShareAppMessage',
					'onMenuShareQQ',
					'onMenuShareWeibo'
					],
					success: function (res) {
					
						
					}
				});
				var shareData = {
					title: wxcard.title,
					desc: wxcard.detail,
					link: window.location.href,
					imgUrl: wxcard.pic,
					trigger: function (res) {
					console.log('用户点击发送给朋友');
					},
					success: function (res) {
					console.log('已分享');
					},
					cancel: function (res) {
					console.log('已取消');
					},
					fail: function (res) {
					console.log(JSON.stringify(res));
					}
					};
				wx.onMenuShareAppMessage(shareData);
				wx.onMenuShareTimeline(shareData);
				wx.onMenuShareQQ(shareData);
				wx.onMenuShareWeibo(shareData);
				});
				wx.error(function (res) {
				console.log(res.errMsg);
				});

			}


		},
		computed: {
			...mapGetters(['getdatas']),

		},

	}
</script>

<style lang="less">
	input {

		border: none;
		outline: none;
	}

	.personr {
		width: 100%;
		display: flex;
		justify-content: center;

		.yulans {
			display: flex;
			flex-direction: column;

			align-items: center;
			width: 95%;
			border-radius: 5px;
			/* border: 1px solid #989898; */

			.yulans-itmes {
				width: 100%;

			}
		}

	}

	.bianju {
		margin-left: 2.5%;
		margin-right: 2.5%;
	}

	.slides-fade-enter {
		transform: translateY(840px);
		opacity: 1;
	}

	.slides-fade-enter-active {
		transition: all .8s ease;
	}

	.slides-fade-leave-to {
		transform: translateY(840px)
	}

	.slides-fade-leave-active {
		transition: all .8s ease;
	}

	.bdlist-move {
		transition: transform .8s;
	}


	.fixcss>div {
		width: 100%;
		min-width: 320px;
		max-width: 540px;
		margin: auto;
		display: flex;
		justify-content: space-around;
		background-color: #dddddd;
		padding-top: 5px;
		padding-bottom: 5px;
		opacity: 0.9;
		border-bottom: 1px solid rgb(221, 219, 219);
	}
</style>


// WEBPACK FOOTER //
// src/manage/UpdatePage.vue